// import React, { useState } from "react";
// import { TextField, Button, Grid, Typography, Box } from "@mui/material";
// import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
// import Cropper from "react-easy-crop";
// import Slider from "@mui/material/Slider";
// import getCroppedImg from "./getCroppedImg"; // Helper function for cropping (see below)

// const AddCategory = () => {
//   const [formData, setFormData] = useState({
//     user_id: "",
//     category_name: "",
//     url: "",
//     created_at: "",
//     updated_at: "",
//     count: ""
//   });

//   // const [image, setImage] = useState(null);
//   // const [croppedArea, setCroppedArea] = useState(null);
//   // const [crop, setCrop] = useState({ x: 0, y: 0 });
//   // const [zoom, setZoom] = useState(1);
//   // const [croppedImage, setCroppedImage] = useState(null);
//   // const [aspectRatio, setAspectRatio] = useState(1); // Aspect ratio control

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   // const handleImageChange = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     const reader = new FileReader();
//   //     reader.readAsDataURL(file);
//   //     reader.onload = () => {
//   //       setImage(reader.result);
//   //     };
//   //   }
//   // };

//   // const onCropComplete = (croppedArea, croppedAreaPixels) => {
//   //   setCroppedArea(croppedAreaPixels);
//   // };

//   // const handleCrop = async () => {
//   //   try {
//   //     const croppedImg = await getCroppedImg(image, croppedArea);
//   //     setCroppedImage(croppedImg);
//   //     alert("Image cropped successfully!");
//   //   } catch (error) {
//   //     console.error("Crop error:", error);
//   //   }
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formDataToSend = new FormData();
//     console.log(formDataToSend);
//     // for (const key in formData) {
//     //   formDataToSend.append(key, formData[key]);
//     // }
//     // if (croppedImage) formDataToSend.append("recipeImage", croppedImage);

//     // console.log(croppedImage);

//     try {
//       const response = await fetch(
//         "http://localhost:3050/api/category/catefiller",
//         {
//           method: "POST",
//           body: formDataToSend,
//         }
//       );

//       const result = await response.json();
//       if (response.ok) {
//         alert(result.message);
//       } else {
//         alert(result.message);
//       }
//     } catch (error) {
//       console.error("Error adding recipe:", error);
//       alert("Error adding recipe, try again later.");
//     }
//   };

//   return (
//     <Box sx={{ padding: 3 }}>
//       <Typography variant="h4" gutterBottom>
//         Add Category
//       </Typography>
//       <form onSubmit={handleSubmit}>
//         <Grid container spacing={3}>
//           {/* Form Fields */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="User ID"
//               variant="outlined"
//               type="number"
//               fullWidth
//               name="user_id"
//               value={formData.user_id}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Category Name"
//               variant="outlined"
//               fullWidth
//               type="text"
//               name="category_name"
//               value={formData.category_name}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="url"
//               variant="outlined"
//               fullWidth
//               type="text"
//               name="url"
//               value={formData.url}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Created At */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Created At(date)"
//               // type="date"
//               variant="outlined"
//               fullWidth
//               name="created_at"
//               value={formData.created_at}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Updated At */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Updated At(date)"
//               variant="outlined"
//               // type="date"
//               fullWidth
//               name="updated_at"
//               value={formData.updated_at}
//               onChange={handleChange}
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Count"
//               variant="outlined"
//               type="number"
//               fullWidth
//               name="count"
//               value={formData.count}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* <Box sx={{ mb: 2 }}>
//             <TextField
//               type="file"
//               fullWidth
//               InputLabelProps={{ shrink: true }}
//               onChange={handleImageChange}
//             />
//           </Box> */}

//           {/* Aspect Ratio Slider */}
//           {/* <Box sx={{ mb: 2 }}>
//             <Typography>Aspect Ratio: {aspectRatio}</Typography>
//             <Slider
//               value={aspectRatio}
//               min={0.1}
//               max={3}
//               step={0.1}
//               onChange={(e, newValue) => setAspectRatio(newValue)}
//             />
//           </Box> */}

//           {/* Other fields... */}

//           {/* Image Upload */}
//           {/* <Grid item xs={12}>
//             <Button
//               variant="contained"
//               component="label"
//               startIcon={<CloudUploadIcon />}
//             >
//               Upload Recipe Image
//               <input type="file" hidden onChange={handleImageChange} />
//             </Button>
//           </Grid> */}

//           {/* Image Cropper */}
//           {/* {image && (
//             <Box
//               sx={{
//                 marginTop: 3,
//                 position: "relative",
//                 height: 300,
//                 width: 300,
//               }}
//             >
//               <Cropper
//                 image={image}
//                 crop={crop}
//                 zoom={zoom}
//                 aspect={aspectRatio} // Set aspect ratio
//                 onCropChange={setCrop}
//                 onZoomChange={setZoom}
//                 onCropComplete={onCropComplete}
//               />
//               <Slider
//                 value={zoom}
//                 min={1}
//                 max={3}
//                 step={0.1}
//                 aria-labelledby="Zoom"
//                 onChange={(e, zoom) => setZoom(zoom)}
//                 sx={{ marginTop: 2 }}
//               />
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 onClick={handleCrop}
//                 sx={{ marginTop: 2 }}
//               >
//                 Crop Image
//               </Button>
//             </Box>
//           )} */}

//           {/* Submit Button */}
//           <Grid item xs={12}>
//

import React, { useState } from "react";
import { TextField, Button, Grid, Typography, Box } from "@mui/material";

const AddCategory = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    user_id: "",
    category_name: "",
    url: "",
    created_at: "",
    updated_at: "",
    count: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send formData as JSON
      const response = await fetch(`${API_URL}/category/catefiller`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (response.ok) {
        alert(result.message || "Category added successfully.");
        setFormData({
          user_id: "",
          category_name: "",
          url: "",
          created_at: "",
          updated_at: "",
          count: "",
        });
      } else {
        alert(result.message || "Category already exists or failed to add.");
      }
    } catch (error) {
      console.error("Error adding category:", error);
      alert("Server error. Try again later.");
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Add Category
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              label="User ID"
              variant="outlined"
              type="number"
              fullWidth
              name="user_id"
              value={formData.user_id}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Category Name"
              variant="outlined"
              fullWidth
              type="text"
              name="category_name"
              value={formData.category_name}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="URL"
              variant="outlined"
              fullWidth
              type="text"
              name="url"
              value={formData.url}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Created At (date)"
              variant="outlined"
              fullWidth
              name="created_at"
              value={formData.created_at}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Updated At (date)"
              variant="outlined"
              fullWidth
              name="updated_at"
              value={formData.updated_at}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Count"
              variant="outlined"
              type="number"
              fullWidth
              name="count"
              value={formData.count}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">
              Add Category
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default AddCategory;
